export default __webpack_public_path__ + "static/media/gift.89b3295d.svg";